export default __webpack_public_path__ + "static/media/pexels-andrea-piacquadio-3769981_2.e779bcf0.jpg";